import { useRecoilValue } from 'recoil';

import { useConfig } from '@chainlit/react-client';

import { isAdmin } from '@/constants/roles';

import { useAuth } from '@/hooks/useAuth';

import { podcastState } from '@/state/podcast';

// Whether the podcast feature is available to the current user right now —
// org-admin, org has it enabled, and this thread doesn't already have one.
// Mirrors DMPodcastMenuItem's own visibility check; kept as a separate copy
// there since that item decides independently whether to render itself.
export function usePodcastAccess(): boolean {
    const { config } = useConfig();
    const { user } = useAuth();
    const podcast = useRecoilValue(podcastState);

    // Until auth and config have actually loaded, report "no access" instead
    // of guessing: a premature `true` mounts the "+" trigger only to unmount
    // it a moment later when the real config lands, which reads as flicker.
    if (!user || !config) return false;

    return (
        isAdmin(user?.metadata?.organization_roles) &&
        config.features?.podcast_enabled !== false &&
        // While a resumed thread's podcast status is still in flight, stay
        // hidden rather than showing and then hiding once has_podcast arrives.
        // resume_thread always dispatches chainlit-podcast-status (even with
        // no podcast), so isLoading reliably clears.
        !podcast.isLoading &&
        !podcast.status?.has_podcast
    );
}
